export default __webpack_public_path__ + "static/media/a03.28852a79.jpg";